/* eslint-disable no-nested-ternary */
import { FC } from 'react'
import { Button, message, Row, Table, Tag, Tooltip } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { RiDownload2Fill } from 'react-icons/ri'
import { BroadcastContactsStatus, Enquiry, EnquiryStatus } from 'types'
import getFullName from 'utils/getFullName'
import getMobileNumber from 'utils/getMobileNumber'
import getFullDate from 'utils/getFullDate'
import useBroadcastEnquiries from 'hooks/useBroadcastEnquiries'

import styles from './styles.module.scss'

const getStatusColor = (status: BroadcastContactsStatus) => {
	switch (status) {
		case 'FAILED':
		case 'DELETED':
			return 'red'
		case 'READ':
		case 'SENT':
			return 'green'
		case 'DELIVERED':
			return '#17a2b8'
		case 'ENQUEUED':
			return 'yellow'
		default:
			return undefined
	}
}

const BroadcastEnquiries: FC = () => {
	const {
		enquiries: records,
		loading,
		page,
		size,
		totalCount,
		setPage,
	} = useBroadcastEnquiries()

	// const { broadcast } = useSingleBroadcast()

	// const [exporting, setExporting] = useState(false)
	//
	// const validateBroadcast = () => {
	// 	if (broadcast === null) {
	// 		throw new Error('Broadcast is null')
	// 	}
	// }

	// const handleExport = async () => {
	// 	setExporting(true);
	// 	try {
	// 		validateBroadcast()
	//
	// 		await downloadUsingAPI(
	// 			await getBroadcastEnquiryExport(broadcast._id),
	// 			`${broadcast.name}-ENQUIRY-REPORT.csv`,
	// 		);
	// 		message.success(`Enquiries has been downloaded.`);
	// 	} catch (error: any) {
	// 		handleAxiosError(error);
	// 	} finally {
	// 		setExporting(false);
	// 	}
	// };

	const columns: ColumnsType<Enquiry> = [
		{
			title: 'Enquiry ID',
			dataIndex: 'enquiryId',
			width: 220,
			fixed: 'left',
		},
		{
			title: 'Date and Time',
			dataIndex: 'createdAt',
			width: 220,
			render: (createdAt: string) => getFullDate(createdAt),
		},
		{
			title: 'Contact Name',
			dataIndex: ['contact', 'firstName'],
			render: (_: string, enquiry) =>
				getFullName({
					firstName: enquiry.contact.firstName,
					lastName: enquiry.contact.lastName ?? undefined,
				}),
		},
		{
			title: 'Mobile Number',
			dataIndex: ['contact', 'mobile'],
			render: (mobile: any) => getMobileNumber(mobile),
		},
		{
			title: 'Message',
			dataIndex: 'message',
			ellipsis: {
				showTitle: false,
			},
			render: (conversationMessage: string) => (
				<Tooltip
					placement='topLeft'
					title={conversationMessage}
					color='#fff'
					overlayInnerStyle={{ color: '#1d3142', padding: 15, lineHeight: 1.4 }}
				>
					{conversationMessage}
				</Tooltip>
			),
		},
		{
			title: 'Status',
			dataIndex: 'status',
			render: (status: EnquiryStatus) => (
				<Tag color={getStatusColor(status as any)}>{status}</Tag>
			),
		},
	]

	return (
		<div>
			<Row justify='end' className={styles.row}>
				<Button
					type='primary'
					icon={<RiDownload2Fill />}
					onClick={() => message.warn('API Missing!')}
				>
					Export
				</Button>
			</Row>
			<Table
				dataSource={records}
				columns={columns}
				loading={loading}
				pagination={{
					current: page,
					pageSize: size,
					total: totalCount,
					onChange: setPage,
				}}
			/>
		</div>
	)
}

export default BroadcastEnquiries
